// extracted by mini-css-extract-plugin
export var button = "_a7-7";
export var buttonRow = "_a7-6";
export var fadeIn = "_a7-1";
export var gradient = "_a7-0";
export var panel = "_a7-2";
export var panelIn = "_a7-3";
export var subtitle = "_a7-5";
export var title = "_a7-4";